export default __webpack_public_path__ + "business.41e7d13.png";